/* global Promise */

import $ from 'dom7';
import Framework7, { getDevice } from 'framework7/bundle';
// qrcode scanner for pwa
// npm i html5-qrcode
// https://www.npmjs.com/package/html5-qrcode
import {Html5QrcodeScanner, Html5Qrcode} from "html5-qrcode";
// Import F7 Styles
import 'framework7/framework7-bundle.css';
// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.css';
// Import Cordova APIs
import cordovaApp from './cordova-app.js';
// Import Routes
import routes from './routes.js';
// Import Store
import store from './store.js';
// Import Server
import server from './server.js';
// Import Storage
import storage from './storage.js';
// Import lang
import lang from './lang.js';
// Import main app component
import App from '../app.f7.html';
// Get Device
var device = getDevice();


// APP VERSION
const APP_VERSION = '1.0.0';
// webapp
//if (!device.cordova) server.host = 'https://webapp.doctorpet.it/';

// create Storage
window.myStorage = storage;
// Set language
window.language = lang;
let userLanguage = localStorage.language || (navigator.language || navigator.userLanguage).substring(0, 2);
window.lng = lang[userLanguage] || lang.en;
// Set documents address
window.DOCUMENTS_ADDRESS = 'https://dreamgest.com/drpass/documents/';

// get ICE Names (translated)
const getIceNames = () => [
    '',
    lng.wife,
    lng.husband,
    lng.brother,
    lng.sister,
    lng.father,
    lng.mother,
    lng.doctor,
    lng.operations_center,
    lng.relative,
    lng.son,
    lng.daughter,
    lng.grandchild,
    lng.center,
    lng.agency,
    lng.association,
    lng.farm,
    lng.dogsitter,
  ];
/**
 * myApp (object)
 */
window.myApp = {
  app_version: APP_VERSION,
  emergency: 112,
  device: device,
  server: server,
  secureMode: false,
  enableSecure: () => {
    myApp.secureMode = true;
    setTimeout(() => myApp.secureMode = false, 300000);
  },
  calendar_hours_limit: 12,
  qrscanpattern: /[\w\-\/]/, // '/drpass/card/',
  calcAge(date) {
    let birthdate = date.constructor.toString().indexOf("Date") > -1 ? date : new Date(date);
    let datediff = new Date(Date.now() - birthdate.getTime());
    return Math.abs(datediff.getUTCFullYear() - 1970);
  },
  user: async (data) => {
    try {
      if (data) {
        if (data.qrcode) delete data.qrcode;
        await myStorage.set('user', data);
        return data;
      }
      else {
        let d = await myStorage.get('user', true);
        return d;
      }
    }
    catch (e) {
      console.log(e.message);
    }
  },
  getMe: async () => {
    try {
      let data = await myApp.server.getJSON('user/me');
      await myApp.user(data);
      return data;
    }
    catch (err) {
      return Promise.reject(err.message);
    }
  },
  getChildren: async (id) => {
    id = id || myApp.children;
    let user = await myApp.user();
    user.data.childrens = user.data.childrens || [];
    let children = user.data.childrens.find(el => el.id === id);
    if (!children) return Promise.reject(lng.user_not_found);
    //children = children || {id: Date.now(), data: {pin: user.data.pin}};
    children.data = children.data || {};
    let inherited_values = 'calendar notifications ice'.split(' ');
    inherited_values.forEach(e => children.data[e] = user.data[e]);
    //user.cardnumber = children.cardnumber;
    //user.id = children.id;
    //user.data = children.data;
    return children;
  },
  setChildren: async (data) => {
    if (data.qrcode) {
      await myStorage.set('qrcode_' + data.id, data.qrcode);
      delete data.qrcode;
    }
    let user = await myApp.user();
    user.data = user.data || {};
    user.data.childrens = user.data.childrens || [];
    let children = user.data.childrens.findIndex(el => el.id == data.id);
    if (children === -1) user.data.childrens.push(data);
    else user.data.childrens[children] = data;
    await myStorage.set('user', user);
    return data;
  },
  iceNames: getIceNames(),
  iceColors: [
    'color-red', // '',
    'color-red', // 'Moglie',
    'color-red', // Marito',
    'color-red', // 'Fratello',
    'color-red', // 'Sorella',
    'color-red', // 'Padre',
    'color-red', // 'Madre',
    'color-blue', // 'Medico',
    'color-blue', // 'Centrale operativa',
    'color-red', // 'Parente',
    'color-red', // 'Figlio',
    'color-red', // 'Figlia',
    'color-red', // 'Nipote',
    'color-secondary', // 'Centro',
    'color-secondary', // 'Azienda',
    'color-secondary', // 'Associazione',
  ],
  userDataRequired: 'pin,name,lastname', // dati richiesti per l'utente.
  // ,birthdate,avatar,sex,address,cap,city,district,country,cf //
  iab(url, target, options) {
    target = target || '_blank';
    options = options || 'location=no,toolbar=no,hardwareback=no,hidenavigationbuttons=yes,zoom=no';
    if (!window.cordova) {
      return window.open(url, url, options);
    }
    const callback = (ev) => {
      if (ev.type == 'loadstart' && ev.url.match('close')) {
        myApp.iabLoadUrl = ev.url;
        ref.close();
      }
      if (ev.type == 'loaderror') {
        ref.close();
        cordovaApp.f7.dialog.alert(lng.error_message + '<br/>' + ev.message);
      }
    };
    const ref = cordova.InAppBrowser.open(url, target, options);
    ref.addEventListener('loadstart', callback);
    ref.addEventListener('loadstop', callback);
    ref.addEventListener('loaderror', callback);
    ref.addEventListener('beforeload', callback);
    ref.addEventListener('message', callback);
    ref.addEventListener('exit', callback);
  },
  getMarketplace: async () => {
    try {
      myApp.marketplace = await myApp.server.getJSON('marketplace');
      console.log('marketplace ok');
      return myApp.marketplace;
    }
    catch (e) {
      console.log(e, 'marketplace error');
      return Promise.resolve(myApp.marketplace);
    }
  },
  marketplace: [],
  localDateTimeInputFormat(date) {
    const fNumber = (number) => {
      let s = '0' + number.toString();
      return s.substring(s.length - 2);
    }
    return date.getFullYear() + '-' +
      fNumber(date.getMonth() + 1) + '-' +
      fNumber(date.getDate()) + 'T' +
      fNumber(date.getHours()) + ':' +
      fNumber(date.getMinutes());
  },
};
/*
 browserHistory: true,
 browserHistorySeparator: '',
 */

/*
 * Framework7
 */
var app = new Framework7({
  name: 'DoctorPet', // App name
  theme: 'auto', // Automatic theme detection
  el: '#app', // App root element
  component: App, // App main component
  id: 'it.doctortag.doctorpet', // App bundle ID
  // App store
  store: store,
  // App routes
  routes: routes,
  view: {
    browserHistory: !device.ios && !device.cordova,
  },
  // Input settings
  input: {
    scrollIntoViewOnFocus: device.cordova && !device.electron,
    scrollIntoViewCentered: device.cordova && !device.electron,
  },
  // Cordova Statusbar settings
  statusbar: {
    iosOverlaysWebView: true,
    androidOverlaysWebView: false,
  },
  photoBrowser: {
    swipeToClose: true,
    pageBackLinkText: lng.back,
    popupCloseLinkText: lng.close,
  },
  dialog: {
    buttonCancel: lng.cancel,
  },
  on: {
    init: async function () {
      var f7 = this;
      const $ = f7.$;
      if (f7.device.cordova) {
        // Init cordova APIs (see cordova-app.js)
        cordovaApp.init(f7);
        myApp.cordova = cordovaApp;
      }
      else {
        document.addEventListener('backbutton', function (e) {
          // ...
        }, false)
      }
      // Init myStorage
      myStorage.f7 = f7;
      await myStorage.init()
      console.log('myStorage INIT OK')
      console.log('User language: ' + lng.key);
      if (await myApp.server.authToken()) {
        myApp.server.getJSON('user/me')
          .then((usr) => myApp.user(usr));
      }
      // FCM -> Aggiorna token se esiste un uuid registrato
      let uuid = await myStorage.get('uuid')
      if (uuid && f7.device.cordova) cordovaApp.messaging();
      // qui tutte le proprietà aggiuntive
      // this.foo = 'bar'

      this.toastError = (e) => {
        f7.toast.show({
          text: lng.error_message + '<br/>' + (e.code ? e.code + ' ' : '') + e.message,
          position: 'bottom',
          closeTimeout: 3000,
          cssClass: 'bg-color-red text-color-white',
        });
      };
      this.toastSuccess = (text) => {
        f7.toast.show({
          text: text,
          position: 'bottom',
          closeTimeout: 3000,
          cssClass: 'bg-color-green text-color-white',
        });
      }

      this.alertError = (e) => {
        f7.dialog.alert(lng.error_message + '<br/>' + (e.code ? e.code + ' ' : '') + e.message);
      }

      this.fetchImage = async (src) => {
        if (!f7.device.cordova) {
          src = src.replace(/api\.dreamgest\.com\/drpet/, 'webapp.doctorpet.it');
        }
        try {
          let res = await fetch(src);
          let blob = await res.blob();
          return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result.length > 5 ? reader.result : '');
            reader.onerror = () => resolve('');
            reader.readAsDataURL(blob);
          });
        }
        catch (e) {
          return Promise.resolve('');
        }
      }

      this.webShareViaEmail = (subject, text) => {
        window.location.href = "mailto:?subject=" + subject + "&body=" + encodeURIComponent(text);
      }

      this.webShareViaWA = (text) => {
        const link = 'https://wa.me/?text=' + text;
        window.open(link);
      }

      let _qrscan;
      this.pwaQrcodeScanner = (cancel) => {

        const stop = () => {
          _qrscan.stop()
            .then(ignore => console.log("QR Code scanning stopped."))
            .catch(err => console.log("Unable to stop scanning."))
            .finally(() => _qrscan = null)
        }

        return new Promise((resolve, reject) => {
          if (cancel === true || cancel === 'stop') {
            stop();
            return resolve({canceled: true, text: ''});
          }
          f7.popup.open('.popup-qrcode-scan');
          _qrscan = new Html5Qrcode("reader");
          _qrscan.start(
            {facingMode: "environment"},
            {fps: 10, qrbox: 250},
            qrCodeMessage => {
              console.log('qrCodeMessage',qrCodeMessage);
              f7.popup.close('.popup-qrcode-scan');
              stop();
              resolve({text: qrCodeMessage});
            },
            errorMessage => {
              console.log('Errore di scansione',errorMessage);
            })
        });
      }
    },
    popupClose() {
      if (myApp.languageChanged) {
        myApp.iceNames = getIceNames();
        myApp.languageChanged = false;
        this.view.main.router.refreshPage();
      }
      if (myApp.reloadPage) {
        myApp.reloadPage = false;
        this.view.main.router.refreshPage();
      }
    },
    pageMounted(a) {
      console.log(a.name + ' mounted');
      if (myApp.languageChanged) {
        myApp.iceNames = getIceNames();
        myApp.languageChanged = false;
      }
    },
    pageBeforeIn(a) {
      console.log(a.name + ' beforeIn');
    },
    pageAfterIn(a) {
      console.log(a.name + ' afterIn');
    },
  },
});